import { Editor } from 'slate'

export function withGiphy(editor: Editor, options: any = {}) {
  return editor
}
